import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _TransportGuide } from '../../../../core/services/dataBean/EntityCatalogVdos';
import usePaginator from '../../../theme/Component/usePaginator';
import useModal, { MODAL_LG } from '../../../theme/Component/hooks/useModal';
import { toast } from 'react-toastify';
import { _CargoManifest, _single } from '../../../../core/services/dataBean/EntityCatalog';
import { Modal } from '../../../theme/Component/Modal';
import { AccountantYear } from '../../../Talentohumano/GestionTH/EmployeeContract/ProductionPlan/AccountantYear';
import { MonthEditorbyconst } from '../../../RemoteAbstractAction/editors/MonthEditorbyconst';
import { AccountEditor } from '../../../editor/AccountEditor';
import { TransportServiceEditor } from '../TransportService/TransportServiceEditor';
import { TransportGuideState } from './TransportGuideState';
import { SelectAccountantConceptCatalogForSalesInvoice } from '../../../contract/etapa-contrato/contrac/ublinvoice/SelectAccountantConceptCatalogForSalesInvoice';
import { CitiesEditor } from '../Countries/Cities/CitiesEditor';
import { GuideDocType } from './GuideDocType';
import { FreightTypeEditor } from '../FreightType/FreightTypeEditor';
import { BasicButton } from '../../../theme/Component/BasicButton';
import { BasicTable, MASK_BOOLEAN, MASK_MONEY, MASK_TEXT_NOWRAP } from '../../../theme/Component/BasicTable';
import { EditorCargoManifest } from '../CargoManifest/EditorCargoManifest';
import { EditorTransportRoute } from '../TransportRoute/EditorTransportRoute';




interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const EditorTransportGuideForCargoManifest = ({ idSelector, onChange, label, returnType = "ID", render }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_CargoManifest);
    const paginador = usePaginator();

    const [id, setID] = useState(null);
    const [text, setText] = useState<string>("")
    const [form, setForm] = useState<any>({
        Agency: null,
        AgencyName: null,
        FreightType: null,
        FreightTypeName: null,
        TransportService: null,
        TransportServiceName: null,
        TransportRoute: null,
        TransportRouteName: null,
        IDCities: null,
        SiteIDName: null,
        GoodsType: null,
        GoodsTypeName: null
    });
    const [Year, setYear] = useState<any>(_single.getCurrenYear())
    const [Month, setMonth] = useState<any>(_single.getCurrentMonth())
    const [GuideState, setGuideState] = useState<any>(null)
    const [Forinvoice, setForinvoice] = useState<any>(null)
    const [IdAcoountsupp, setIdAcoountsupp] = useState<any>(null)
    const [IdAcoountcutom, setIdAcoountcustom] = useState<any>(null)
    const [idCargoManifest, setidCargoManifest] = useState<any>(null)
    const [TransGuide, setTransGuide] = useState<any>(null)
    const [TransCode, setTransCode] = useState<any>(null)
    const [Doc, setDoc] = useState<any>(null)
    const defaultOffice = _single.getOffice();


    const modal = useModal("Guias de transporte", MODAL_LG);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        if (render) {
            setText(render)
        }
    }, [render])

    useEffect(() => {
        getLista();
    }, [paginador.page])


    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDTransportGuide == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
                modal.close();
                if (selectedItem.DataBeanProperties.IDTransportGuide) {
                    setText(`${selectedItem.DataBeanProperties.IDTransportGuide} - ${selectedItem.DataBeanProperties.TransportGuideDate}`)
                }
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const renderUserAdressed = (item: any) => {
        let render =
            ` 
        <div>            
            <strong>NIT: </strong><small>${item.DataBeanProperties.IDAccountAddressee ? item.DataBeanProperties.AccountAddresseeNit : 'NA'}</small><br />
            <strong>Contacto: </strong><small>${item.DataBeanProperties.IDAccountAddressee ? item.DataBeanProperties.AccountAddresseeName : 'NA'}</small><br />            
            <strong>Dirección: </strong><small>${item.DataBeanProperties.IDAccountAddressee ? item.DataBeanProperties.AccountAddressesAddress : 'NA'}</small><br />            
            <strong>Correo: </strong><small>${item.DataBeanProperties.IDAccountAddressee ? item.DataBeanProperties.AccountAddresseeEmail : 'NA'}</small><br />            
            <strong>Telefono: </strong><small>${item.DataBeanProperties.IDAccountAddressee ? item.DataBeanProperties.AccountAddresseeTel : 'NA'}</small><br />            
        </div>
        `
        return render;
    }

    const renderUserSender = (item: any) => {
        let render =
            ` 
        <div>            
            <strong>NIT: </strong><small>${item.DataBeanProperties.IDAccountCustomer ? item.DataBeanProperties.AccountCustomerNit : 'NA'}</small><br />
            <strong>Contacto: </strong><small>${item.DataBeanProperties.IDAccountCustomer ? item.DataBeanProperties.AccountCustomerName : 'NA'}</small><br />            
            <strong>Dirección: </strong><small>${item.DataBeanProperties.IDAccountCustomer ? item.DataBeanProperties.AccountAddress : 'NA'}</small><br />            
            <strong>Correo: </strong><small>${item.DataBeanProperties.IDAccountCustomer ? item.DataBeanProperties.AccountEmail : 'NA'}</small><br />            
            <strong>Telefono: </strong><small>${item.DataBeanProperties.IDAccountCustomer ? item.DataBeanProperties.AccountTel : 'NA'}</small><br />            
        </div>
        `
        return render;
    }

    const getLista = () => {
        instance.getTransportGuideListForCargoManifest(Year, Month,  IdAcoountcutom, IdAcoountsupp, defaultOffice.IDOffice, form.TransportRoute,
            form.TransportService, GuideState, Forinvoice, TransGuide, null, TransCode, form.IDCities, Doc, form.FreightType, null, paginador.page, 15).then(
                (resp: any) => {
                    if (resp) {
                        paginador.setPages(resp.NumberOfPages);
                        paginador.setRecords(resp.NumberOfPages * (15));
                        paginador.setRegiPerPage(15)
                        // setLista(resp.List)
                        let x = resp.List;
                        x.forEach((guide) => {
                            guide.DataBeanProperties.Rute = (guide.DataBeanProperties.TransportDestinationOrigin ?? "") + "-" + (guide.DataBeanProperties.TransportDestinationDestinity ?? "");
                            guide.DataBeanProperties.EntityAdressed = renderUserAdressed(guide);
                            guide.DataBeanProperties.EntitySender = renderUserSender(guide);


                        });
                        setLista(x)
                    }
                }
            ).catch(err => {
                toast.error("Error al cargar las guias de transporte");
            });
    };

    const head = [
        { title: 'ID', property: 'IDTransportGuide', visible: true },
        { title: 'Fecha Emisión', property: 'TransportGuideDate', visible: true },
        { title: 'Código Guia', property: 'TransportGuideCode', visible: true },
        { title: 'Consecutivo GUIA', property: 'TransportGuideConsecutive', visible: true },
        { title: 'Estado', property: 'StateName', visible: true },
        { title: 'Oficina', property: 'OfficeName', visible: true, mask: MASK_TEXT_NOWRAP },
        { title: 'Caja', property: 'CashDeskAccountName', visible: true },
        { title: 'Empleado', property: 'EmployeeName', visible: true },
        { title: 'Tipo Documento', property: 'TransportGuideDocTypeName', visible: true },
        { title: 'Utiliza Convenio', property: 'UseProject', visible: true, mask: MASK_BOOLEAN },
        { title: 'Convenio', property: 'ProjectName', visible: true },
        { title: 'Cliente', property: 'EntitySender', visible: true, Style: { minWidth: "250px" } },
        { title: 'Servicio de Entrega', property: 'TransportServiceName', visible: true },
        { title: 'Tipo Facturación', property: 'InvoiceFreightTypeName', visible: true },
        { title: 'Número de Piezas', property: 'PiecesNumber', visible: true },
        { title: 'Ruta de Carga', property: 'Rute', visible: true },
        { title: 'Formas de Pago', property: 'PaymentMeansID', visible: true },
        { title: 'Métodos de Pago', property: 'PaymentMeansCode', visible: true },
        { title: 'Valor Guía', property: 'TotalAmount', visible: true },
        { title: 'Descuentos', property: 'DiscountAmount', visible: true },
        { title: 'Total Pagos', property: 'TotalPayment', visible: true },
        { title: 'Facturar a', property: 'InvoiceToTypeName', visible: true },
        { title: 'Conctacto Cliente', property: 'EntityAdressed', visible: true, Style: { minWidth: "250px" } },
        { title: 'Estado de Carga', property: 'GoodsStateName', visible: true },
        { title: 'Soporte de Carga', property: 'GoodsSupportName', visible: true },
        { title: 'Tipo de Bienes', property: 'GoodsTypeName', visible: true },
        { title: 'Tipo de Carga', property: 'FreightTypeName', visible: true },
        { title: 'Valor Declarado', property: 'GoodsValue', visible: true, mask: MASK_MONEY },
        { title: 'Observaciones Carga', property: 'GoodsDescription', visible: true },
    ]

    return (
        <>
            <label>{label ?? "Guias de Transporte"}</label>
            <span className='form-control cursor ifmodal' onClick={() => modal.open()}>{text.trim() ? text : "Seleccione una Guia de transporte"}</span>

            <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { setValue(bean.IDTransportGuide) }}>
                <div className="row">

                    <div className="col-md-6">
                        <AccountantYear idSelector={Year} onChange={(e) => { setYear(e) }} />
                    </div>
                    <div className="col-md-6">
                        <MonthEditorbyconst idSelector={Month} onChange={(e) => { setMonth(e) }} />
                    </div>
                    <div className="col-md-6">
                        <EditorCargoManifest idSelector={idCargoManifest} onChange={(e) => { setidCargoManifest(e) }} />
                    </div>
                    <div className="col-md-6">
                        <AccountEditor label="Cliente" idAccount={IdAcoountcutom} onChange={(e) => { setIdAcoountcustom(e.IDAccount) }} />
                    </div>
                    <div className="col-md-6">
                        <AccountEditor label="Proveedor" idAccount={IdAcoountsupp} onChange={(e) => { setIdAcoountsupp(e.IDAccount) }} />
                    </div>
                    <div className="col-md-6">
                        <EditorTransportRoute render={form.TransportRouteName} idSelector={form.TransportRoute} onChange={(e) => { setForm({ ...form, "TransportRoute": e.IDTransportRoute, "TransportRouteName": e.Route }) }} returnType="Object" />
                    </div>
                    <div className="col-md-6">
                        <TransportServiceEditor render={form.TransportServiceName} idSelector={form.TransportService} onChange={(e) => { setForm({ ...form, "TransportService": e.IDTransportService, "TransportServiceName": e.Name }) }} returnType="Object" />
                    </div>
                    <div className="col-md-6">
                        <TransportGuideState idSelector={GuideState} onChange={(e) => { setGuideState(e) }} />
                    </div>
                    <div className="col-md-6">
                        <SelectAccountantConceptCatalogForSalesInvoice idSelector={Forinvoice} onChange={(e) => { setForinvoice(e) }} />
                    </div>
                    <div className="col-md-6">
                        <label>ID Guía de Transporte</label>
                        <input type="text" className="form-control" value={TransGuide} onChange={(e: any) => { setTransGuide(parseInt(e)) }} />
                    </div>
                    <div className="col-md-6">
                        <label>Código de Guía de Transporte</label>
                        <input type="text" className="form-control" value={TransCode} onChange={(e: any) => { setTransCode(parseInt(e)) }} />
                    </div>
                    <div className="col-md-6">
                        <CitiesEditor render={form.SiteIDName} idSelector={form.IDCities} onChange={(e) => { setForm({ ...form, "IDCities": e.IDCities, "SiteIDName": e.Name }) }} returnType="Object" />
                    </div>
                    <div className="col-md-6">
                        <GuideDocType idSelector={Doc} onChange={(e) => { setDoc(e) }} />
                    </div>
                    <div className="col-md-6">
                        <FreightTypeEditor render={form.FreightTypeName} idSelector={form.FreightType} onChange={(e) => { setForm({ ...form, "FreightType": e.IDFreightType, "FreightTypeName": e.Name }) }} returnType="Object" />
                    </div>
                    <div className="col-md-6 mt-4 p-2">
                        <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                    </div>
                    <div className="col-md-12">
                        <BasicTable body={lista} head={head} rowSet={setBean} records={paginador} />
                    </div>
                </div>

            </Modal>
        </>
    )
}